import { unit } from '../../common/theme';
import { styled } from '../../providers/context/StyletronProvider/withStyletronProvider';

export const TabsContainer = styled('div', () => ({
  marginBottom: unit[6],
}));
